import '../styles/About.css';

function About() {
  return (
    <section className="about" id="apropos">
      <div className="about-container">
        <div className="about-content">
          <span className="section-label">À propos</span>
          <h2 className="about-title">
            Une académie pensée<br />
            pour votre indépendance
          </h2>
          <p className="about-text">
            Ummah Élite Academy forme une nouvelle génération
            capable de créer des revenus en ligne grâce aux
            compétences digitales.
          </p>
          <p className="about-text">
            <strong>Notre objectif :</strong> vous rendre autonome, avec une
            approche sérieuse, éthique et durable.
          </p>
          <a href="#formations" className="btn btn-primary">Voir les formations</a>
        </div>
        <div className="about-image">
          {/* Image will be added later */}
          <div className="about-image-placeholder"></div>
        </div>
      </div>
    </section>
  );
}

export default About;
